/**
 * Labstep
 *
 * @module components/ShareLink/Accept/Entity
 * @desc Components to accept sharelink for entities
 */

import { FieldType } from 'labstep-web/constants/form';
import { Button } from 'labstep-web/core/Button';
import { FormReusable } from 'labstep-web/core/Form/Reusable';
import type { FieldWithoutActionProps } from 'labstep-web/core/Form/Reusable/types';
import { Group } from 'labstep-web/models/group.model';
import { ShareLinkHeader } from 'labstep-web/screens/Authentication/Signin/ShareLinkHeader';
import { getHumanReadableEntityName } from 'labstep-web/services/i18n.service';
import type React from 'react';
import { object } from 'yup';
import type { IShareLinkAcceptEntityProps } from './types';

export const fieldWorkspace: FieldWithoutActionProps = {
  fieldType: FieldType.SearchSelect,
  name: 'workspace',
  validation: object().required(),
  elementProps: {
    entityName: Group.entityName,
    creatable: true,
  },
};

export const ShareLinkAcceptEntity: React.FC<
  IShareLinkAcceptEntityProps
> = ({ shareLink, onChange, status }) => {
  return (
    <div>
      <ShareLinkHeader sign={null} shareLink={shareLink} />
      <p>
        {`Please select / create a workspace to save this
        ${getHumanReadableEntityName(
          shareLink.entity.entityName,
        )} to...`}
      </p>
      <FormReusable
        fields={[fieldWorkspace]}
        status={status}
        submitButtonText="Accept"
        onSubmit={(values) => {
          onChange({ id: values.workspace_id as number });
        }}
        cancelButton={
          <Button
            status={status}
            primary
            basic
            route={{ to: 'app_homepage' }}
          >
            Reject
          </Button>
        }
      />
    </div>
  );
};
